import React from "react";

const ScheduleCourtsIconwithNumber = (props: any) => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.25746 6.2166C6.25746 6.61902 6.17379 6.96766 6.00645 7.2625C5.8391 7.55734 5.61199 7.7984 5.32512 7.98566C5.04223 8.17293 4.72348 8.31039 4.36887 8.39805V8.43391C5.07012 8.52156 5.60203 8.73672 5.96461 9.07938C6.33117 9.42203 6.51445 9.88023 6.51445 10.454C6.51445 10.964 6.38895 11.4202 6.13793 11.8226C5.8909 12.225 5.5084 12.5418 4.99043 12.7729C4.47246 13.004 3.80508 13.1195 2.98828 13.1195C2.50617 13.1195 2.05594 13.0797 1.63758 13C1.2232 12.9243 0.832734 12.8068 0.466172 12.6474V11.0755C0.840703 11.2668 1.23316 11.4122 1.64355 11.5118C2.05395 11.6075 2.43645 11.6553 2.79105 11.6553C3.45246 11.6553 3.91465 11.5417 4.17762 11.3146C4.44457 11.0835 4.57805 10.7608 4.57805 10.3464C4.57805 10.1034 4.51629 9.89816 4.39277 9.73082C4.26926 9.56348 4.0541 9.43598 3.7473 9.34832C3.44449 9.26066 3.02016 9.21684 2.4743 9.21684H1.8109V7.80039H2.48625C3.02414 7.80039 3.43254 7.75059 3.71145 7.65098C3.99434 7.54738 4.18559 7.40793 4.2852 7.23262C4.38879 7.05332 4.44059 6.85012 4.44059 6.62301C4.44059 6.31223 4.34496 6.06918 4.15371 5.89387C3.96246 5.71855 3.64371 5.6309 3.19746 5.6309C2.91855 5.6309 2.66355 5.66676 2.43246 5.73848C2.20535 5.80621 2.00016 5.88988 1.81687 5.98949C1.63359 6.08512 1.47223 6.17875 1.33277 6.27039L0.478125 4.99738C0.820781 4.75035 1.22121 4.54516 1.67941 4.3818C2.1416 4.21844 2.69145 4.13676 3.32895 4.13676C4.22941 4.13676 4.94262 4.31805 5.46855 4.68063C5.99449 5.0432 6.25746 5.5552 6.25746 6.2166Z"
        fill="currentColor"
      />
      <path
        d="M14.4061 10.6921H13.8076V5.48851C13.8076 3.79547 15.1851 2.41797 16.8781 2.41797H20.5346V3.01641H16.8781C15.5148 3.01641 14.4061 4.1257 14.4061 5.48851V10.6921Z"
        fill="currentColor"
      />
      <path
        d="M14.4061 12.1367H13.8076V19.708H14.4061V12.1367Z"
        fill="currentColor"
      />
      <path
        d="M23.2541 21.497H19.5977V20.8985H23.2541C24.6175 20.8985 25.7262 19.7892 25.7262 18.4264V11.9453H26.3246V18.4264C26.3246 20.1195 24.9471 21.497 23.2541 21.497Z"
        fill="currentColor"
      />
      <path
        d="M26.324 4.21094H25.7256V10.6969H26.324V4.21094Z"
        fill="currentColor"
      />
      <path
        d="M25.1986 13.0015H14.9332L11.3018 10.3945H28.8295L25.1986 13.0015ZM15.1263 12.4031H25.006L26.9705 10.993H13.1618L15.1263 12.4031Z"
        fill="currentColor"
      />
      <path
        d="M20.2313 12.7031H19.6328V17.5826H20.2313V12.7031Z"
        fill="currentColor"
      />
      <path
        d="M20.2313 5.47266H19.6328V10.6954H20.2313V5.47266Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ScheduleCourtsIconwithNumber;
